import { Button } from "@root/shared/components/Button";
import { type FC } from "react";
import * as styles from "./styles.css";

type Props = {
  clientName: string;
  clientShopName?: string;
  onClick: () => void;
};

export const ClientSelectInfoBox: FC<Props> = ({ clientName, clientShopName, onClick }) => {
  return (
    // FIXME: Tableコンポーネント再設計後に置き換え
    <table className={styles.table}>
      <tbody>
        <tr className={styles.tr}>
          <th className={styles.th}>{clientName}</th>
          <td className={styles.td}>
            <div className={styles.tdInner}>
              <p className={styles.shopName}>{clientShopName || "店舗は指定しない"}</p>
              <div className={styles.buttonWrapper}>
                <Button theme="secondary" onClick={onClick} className={styles.button} size="small">
                  変更
                </Button>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  );
};
